import { render, staticRenderFns } from "./operatingDetail.vue?vue&type=template&id=b698e34c&scoped=true"
import script from "./operatingDetail.vue?vue&type=script&lang=js"
export * from "./operatingDetail.vue?vue&type=script&lang=js"
import style0 from "./operatingDetail.vue?vue&type=style&index=0&id=b698e34c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b698e34c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b698e34c')) {
      api.createRecord('b698e34c', component.options)
    } else {
      api.reload('b698e34c', component.options)
    }
    module.hot.accept("./operatingDetail.vue?vue&type=template&id=b698e34c&scoped=true", function () {
      api.rerender('b698e34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/operatingDetail.vue"
export default component.exports